import type { MagazineAnalyticsSettingFormModel, ServerModel } from "../../../type";

export const serverModelToInputModel = (serverModel: ServerModel): MagazineAnalyticsSettingFormModel["InputModel"] => {
	const { hotelID, gtmID, gtmAvailable, pixelID, pixelAvailable } = serverModel.magazineAnalyticsSetting;
	const { magazineVisibility } = serverModel.guestPageVisibilitySettings;

	const inputModel: MagazineAnalyticsSettingFormModel["InputModel"] = {
		hotelID,
		gtmID,
		gtmAvailable,
		pixelID,
		pixelAvailable,
		guestPageVisibility: magazineVisibility,
	} satisfies MagazineAnalyticsSettingFormModel["InputModel"];

	return inputModel;
};
